module.exports = __webpack_public_path__ + "static/media/AI-search-campaign-01.a8184827.svg";